import { useState } from 'react';

import { Box, Stack } from '@mui/material';

import { usePaymentState } from '../../hooks/use-payment-state';
import { AddressElement } from '../AddressElement/AddressElement';
import { useAddressElementRef } from '../AddressElement/hooks/use-address-element-ref';
import { useShowTaxCalculationFields } from '../../hooks/use-show-tax-calculation-fields';
import { PaymentMethodNotSupported } from '../PaymentMethodNotSupported/PaymentMethodNotSupported';
import { AdyenGooglePay } from '../ExpressCheckout/components/AdyenGooglePay/AdyenGooglePay';

export function AdyenGoogleApmButton() {
  const setIsPaymentElementLoading = usePaymentState((state) => state.setIsPaymentElementLoading);
  const setIsApmLoading = usePaymentState((state) => state.setIsApmLoading);
  const isPaymentLoading = usePaymentState((state) => state.isPaymentLoading);
  const [isGooglePayAvailable, setIsGooglePayAvailable] = useState(true);
  const [isAddressValid, setIsAddressValid] = useState(false);
  const { useTaxCalculationField, showAddressField } = useShowTaxCalculationFields();
  const { AddressElementRef } = useAddressElementRef();

  const isBlockOverlay = (useTaxCalculationField && !isAddressValid) || isPaymentLoading;

  if (!isGooglePayAvailable) {
    return <PaymentMethodNotSupported />;
  }

  return (
    <Stack spacing={2}>
      {useTaxCalculationField && (
        <AddressElement
          ref={AddressElementRef}
          zipOnly={!showAddressField}
          onValidationChange={(isValid) => setIsAddressValid(isValid)}
        />
      )}
      <Box position={'relative'}>
        {isBlockOverlay && (
          <Box
            position={'absolute'}
            onClick={() => {
              AddressElementRef.current?.validate();
            }}
            width={'100%'}
            height={'100%'}
            zIndex={999999}
          />
        )}
        <AdyenGooglePay
          onReady={(isAvailable) => {
            setIsGooglePayAvailable(isAvailable);
            setIsApmLoading(false);
            setIsPaymentElementLoading(false);
          }}
        />
      </Box>
    </Stack>
  );
}
